import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getUserById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_USER_BY_ID + id,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getUserList = (query = "") => {
  return new Promise((resolve, reject) => {
    const base = process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_USERS;
    const url = query ? `${base}${query}` : base; 
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const createWalletByUserId = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }

    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.WALLET_CREATE_BY_ID,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ userId })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getWalletByUserId = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }

    callAPI(
      process.env.REACT_APP_APIUrl + `user/admin/wallet/${userId}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const addWalletAmountByAdmin = (userId, amount, password, note, operationType) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.WALLET_ADMIN_ADD_AMOUNT +
        userId +
        "/add-funds",
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ amount, password, note, operationType })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getWalletEditHistory = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.WALLET_ADMIN_ADD_AMOUNT +
        userId +
        "/edit-history",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const updateUser = (id, payload) => {
  return new Promise((resolve, reject) => {
    const userId = typeof id === 'object' ? id._id || id.id : id;
    if (!userId || !payload) {
      reject(new Error('User ID and payload are required'));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPDATE_USER + userId,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(payload)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getTodayRegisterUser = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_USERS_DAILY_REPORT,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ============= CREDIT API SERVICES (separate from wallet) =============

const setCreditAmount = (userId, amount, password, note) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl + `admin/credit/${userId}/set-credit`,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ amount, password, note })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getCreditByUserId = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl + `admin/credit/${userId}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getAllUsersWithCredit = (query = "") => {
  return new Promise((resolve, reject) => {
    const base = process.env.REACT_APP_APIUrl + "admin/users/credit";
    const url = query ? `${base}${query}` : base;
    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getCreditHistory = (userId) => {
  return new Promise((resolve, reject) => {
    if (!userId) {
      reject(new Error("User ID is required"));
      return;
    }
    callAPI(
      process.env.REACT_APP_APIUrl + `admin/credit/${userId}/history`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const userApiService = {
  getUserById,
  getUserByID: getUserById,
  getUserList,
  createWalletByUserId, // create wallet by user id (temporarily)
  getWalletByUserId, // get wallet by user id
  addWalletAmountByAdmin, // add/subtract amount to user wallet by admin
  getWalletEditHistory, // get wallet edit history by admin
  updateUser,
  getTodayRegisterUser,
  // Credit management (separate from wallet)
  setCreditAmount,
  getCreditByUserId,
  getAllUsersWithCredit,
  getCreditHistory,
};